import { render, staticRenderFns } from "./CenterOfMassViz.vue?vue&type=template&id=55fbb9da&scoped=true"
import script from "./CenterOfMassViz.vue?vue&type=script&lang=js"
export * from "./CenterOfMassViz.vue?vue&type=script&lang=js"
import style0 from "./CenterOfMassViz.vue?vue&type=style&index=0&id=55fbb9da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fbb9da",
  null
  
)

export default component.exports